export enum PO_CHANGE_FORM_NUMBER {
  TOTAL_CANCELLATION_NUMBER = '1',
  CHANGE_DESCRIPTION_NUMBER = '2',
  INCREASE_DECREASE_AMOUNT_NUMBER = '3',
  INCREASE_DECREASE_AMOUNT_TERMINATED_NUMBER = '4',
}
